<app-smart-input-entity
  fieldLabel="name"
  [control]="control()"
  [handler]="workPackagePickerHandler()"
  [placeholder]="placeholder()"
  [showTooltip]="true"
  [resetValue]="resetValue()">
  <ng-template
    let-item="item"
    appTemplate="filter">
    @if (cast(item); as wp) {
      <app-avatar
        [showName]="true"
        [name]="wp.name"
        [icon]="'task'"
        [color]="getColor | call: wp"></app-avatar>
    }
  </ng-template>
</app-smart-input-entity>
